// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3xV1V","rootSuccess":"CompleteLink_rootSuccess__3X8VK","rootFailure":"CompleteLink_rootFailure__3vWq-","isDisabled":"CompleteLink_isDisabled__24HaV"};